import { Component, Input } from '@angular/core';
import { NgbActiveModal }  from '@ng-bootstrap/ng-bootstrap';

import { ApiService }      from '../../app-lite/api/api.service';
import { MessagesService } from '../../app-lite/messages/messages.service';

@Component({
  selector   : 'wor-vv-garage-add-customer',
  template: require('./vv-garage-add-customer.component.html')
})
export class VvGarageAddCustomerComponent {
  @Input() vvGarage: any;

  constructor (
    public activeModal: NgbActiveModal,
    private apiService: ApiService,
    private messagesService: MessagesService
  ) {}

  create (): void {
    this.apiService.post('/vv_garage/add_customer', this.vvGarage.vv_garage, 'vv_garage')
      .then(() => this.activeModal.close())
      .catch((err: any) => this.messagesService.error(err));
  }
}
